// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_PreflightClientesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /migration/clientes/preflight
 * (controllers/migration/clientes.php::preflight).
 *
 * Uma linha por cliente da franquia pedida, com o de-para ja executado.
 * Leitura pura — nada foi escrito para montar isto. A franquia maior tem
 * ~5.500 linhas (a tela pagina; o payload e ~1 MB e passa).
 */
import type { Migration_PreflightClienteRow } from './Migration_PreflightClienteRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_PreflightClientesResponseDados {
registros: Migration_PreflightClienteRow[]
}

export type Migration_PreflightClientesResponse = ApiResponse<Migration_PreflightClientesResponseDados>;

registerResponseContract('Migration_PreflightClientesResponse', {
  registros: {
    type: 'array',
    required: true,
    items: {
      zoho_id:    { type: 'string',  required: false },
      nome:       { type: 'string',  required: false },
      documento:  { type: 'string',  required: false },
      telefone:   { type: 'string',  required: false },
      cidade:     { type: 'string',  required: false },
      origem:     { type: 'string',  required: false },
      ja_migrado: { type: 'boolean', required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
    },
  },
})
